// Messages of the TypeError that fetch() throws when a request never reaches
// the server (connection dropped, offline, request cancelled). These are
// transient client-side failures, not application bugs, so we don't report
// them to Sentry.
const NETWORK_ERROR_MESSAGES = [
  "Failed to fetch", // Chrome, Edge
  "NetworkError when attempting to fetch resource", // Firefox
  "Load failed", // Safari
];

export function isBenignNetworkError(error: unknown): boolean {
  return (
    error instanceof TypeError &&
    NETWORK_ERROR_MESSAGES.some((message) => error.message.includes(message))
  );
}
